export const environment = {
    production: true,
    localAppUrl: 'http://localhost:4200',
    personalDetailsPlaceholder: 'HIDDEN',
    appMode: 'PUBLIC',
    hideDarkMode: true,
    siteKey: "6LfLNXEpAAAAAE-c13qZe3iV5poLYdZitmYv0M2s",
    leaveGracePeriodDays: 5
};
